export const environment = {
  production: true,
  authServer: 'https://gw-dev.riatlas.it/authorization',
  resourceServer: 'https://gw-dev.riatlas.it/resource',
  fhirServer: 'https://gw-dev.riatlas.it/fhir',
  elastic: 'https://gw-dev.riatlas.it/resource',
  mobile: 'https://gw-dev.riatlas.it/mobile',
  company: 'Riatlas.it',
  baseHref: 'cloud'
};
